var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "modal-backdrop fade show" }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade show d-block",
        attrs: { tabindex: "-1", role: "dialog" },
        on: {
          click: function ($event) {
            if ($event.target !== $event.currentTarget) return null
            return _vm.$emit("hide-modal")
          },
        },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-lg" }, [
          _c("div", { staticClass: "modal-content shadow-lg" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn-close",
                attrs: { "aria-label": "Close", type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("hide-modal")
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("form", { staticClass: "form-horizontal px-3" }, [
                _c("div", { staticClass: "mb-4 row align-items-center" }, [
                  _c(
                    "label",
                    { staticClass: "col-sm-4 col-lg-3 form-label fw-bold" },
                    [_vm._v("Image")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-8 col-lg-9" },
                    [
                      _c(_setup.ImageSelection, {
                        attrs: {
                          "file-id": _setup.fileId,
                          "on-change": _setup.onImageSelection,
                          "form-id": _vm.formId,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-4 row" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-sm-4 col-lg-3 form-label",
                      attrs: { for: "altText" },
                    },
                    [_vm._v("Alt Text")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-8 col-lg-9" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.attrs.alt,
                          expression: "attrs.alt",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "altText",
                        disabled: !_setup.fileId,
                        placeholder: "",
                      },
                      domProps: { value: _setup.attrs.alt },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_setup.attrs, "alt", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-4 row" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-sm-4 col-lg-3 form-label",
                      attrs: { for: "title" },
                    },
                    [_vm._v("Title")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-8 col-lg-9" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.attrs.title,
                          expression: "attrs.title",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { id: "title", disabled: !_setup.fileId },
                      domProps: { value: _setup.attrs.title },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_setup.attrs, "title", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-4 row" }, [
                  _c("label", { staticClass: "col-sm-4 col-lg-3 form-label" }, [
                    _vm._v("Alignment"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-8 col-lg-9" }, [
                    _c(
                      "div",
                      { staticClass: "btn-group w-100" },
                      _vm._l(
                        ["none", "left", "center", "right"],
                        function (align) {
                          return _c(
                            "button",
                            {
                              key: align,
                              staticClass: "btn btn-outline-secondary px-3",
                              class: {
                                active: _setup.currentAlignment === align,
                              },
                              attrs: {
                                type: "button",
                                disabled: !_setup.fileId,
                              },
                              on: {
                                click: function ($event) {
                                  return _setup.setAlignment(align)
                                },
                              },
                            },
                            [
                              align !== "none"
                                ? _c("i", {
                                    class: `bi-align-${
                                      align === "left"
                                        ? "start"
                                        : align === "right"
                                        ? "end"
                                        : "center"
                                    }`,
                                  })
                                : _c("span", [_vm._v("None")]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-4 row" }, [
                  _c(
                    "label",
                    {
                      staticClass: "col-sm-4 col-lg-3 form-label",
                      attrs: { for: "width" },
                    },
                    [_vm._v("Dimensions")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-sm-8 col-lg-9 d-flex align-items-center",
                    },
                    [
                      _c("div", { staticClass: "input-group" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v("W"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: _setup.attrs.width,
                              expression: "attrs.width",
                              modifiers: { number: true },
                            },
                          ],
                          staticClass: "form-control text-center",
                          attrs: {
                            id: "width",
                            disabled: !_setup.fileId,
                            type: "number",
                          },
                          domProps: { value: _setup.attrs.width },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _setup.attrs,
                                  "width",
                                  _vm._n($event.target.value)
                                )
                              },
                              _setup.setWidth,
                            ],
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v("H"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: _setup.attrs.height,
                              expression: "attrs.height",
                              modifiers: { number: true },
                            },
                          ],
                          staticClass: "form-control text-center",
                          attrs: {
                            id: "height",
                            disabled: !_setup.fileId,
                            type: "number",
                          },
                          domProps: { value: _setup.attrs.height },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _setup.attrs,
                                  "height",
                                  _vm._n($event.target.value)
                                )
                              },
                              _setup.setHeight,
                            ],
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "ms-2 btn btn-light border",
                          class: {
                            "btn-warning border-warning": _setup.lockRatio,
                          },
                          attrs: {
                            disabled: !_setup.fileId,
                            type: "button",
                            title: "Lock Aspect Ratio",
                          },
                          on: {
                            click: function ($event) {
                              _setup.lockRatio = !_setup.lockRatio
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "bi",
                            class: _setup.lockRatio
                              ? "bi-lock-fill"
                              : "bi-unlock",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "ms-1 btn btn-light border",
                          attrs: {
                            disabled: !_setup.fileId,
                            type: "button",
                            title: "Reset to Original",
                          },
                          on: { click: _setup.refreshDimensions },
                        },
                        [_c("i", { staticClass: "bi-arrow-clockwise" })]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("h4", { staticClass: "modal-title" }, [
      _c("i", { staticClass: "bi-image me-2" }),
      _vm._v("Image Properties\n                    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }